import React from 'react'
import styled from 'styled-components'
import Benefit from '../Benefits/Benefit'
import { benefits } from '../../utils/constants'

const Home = () => {
  return (
    <Section>
      <Title>Why shop with us</Title>
      <Grid>
        {benefits.map(benefit => (
          <Benefit key={benefit.title} benefit={benefit} />
        ))}
      </Grid>
    </Section>
  )
}
export default Home

const Section = styled.section`
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 16px;

  @media screen and (min-width: 768px) {
    padding: 48px 24px;
  }
`;

const Title = styled.h2`
  margin: 0 0 22px;
  text-align: center;
  font-size: clamp(1.3rem, 2.6vw, 1.7rem);
  font-weight: 800;
  color: #1f2d3d;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media screen and (min-width: 420px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (min-width: 900px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
